import React, { useState, useEffect } from 'react';

interface CartItem {
	productName: string;
	quantity: number;
	meta?: { [key: string]: any };
}

export type InventoryItem = { name: string; id: number; price: number; titles: string[]; discountedPrice: number | undefined | null };
export type Inventory = { items: InventoryItem[] };

const useInventory = (): [InventoryItem[], boolean] => {
	const [result, setResult]: [InventoryItem[], React.Dispatch<React.SetStateAction<InventoryItem[]>>] = useState([] as InventoryItem[]);
	const [loaded, setLoaded] = useState(false);

	useEffect(() => {
		const fetchInventory = async () => {
			try {
				setLoaded(false);

				fetch('/inventory.json')
					.then(res => res.json())
					.then((inventory: Inventory) => {
						const items = inventory.items;

						const notebook1 = items.find(item => item.name === 'notebook1') as InventoryItem;
						items.push({ ...notebook1, name: `${notebook1.name}_gift`, id: 8718 });

						setResult(items);
						setLoaded(true);
					});
			} catch (error) {
				console.error(error);
				setLoaded(false);
			}
		};

		fetchInventory();
	}, []);

	return [result, loaded];
};

const makeCartItem = (productName: string, quantity?: number, meta?: { [key: string]: any }): CartItem => {
	const plainObject: CartItem = {
		productName,
		quantity: quantity ?? 1,
		meta,
	};

	return plainObject;
};

export { makeCartItem, useInventory };
export default CartItem;
